import { ReturnClientStore } from "@domain/stores/ReturnClientStore";
import { create } from "zustand";

type InitialState = Pick<ReturnClientStore, "dashboardReturns" | "returns">;

const initialState: InitialState = {
  dashboardReturns: {
    completed: [],
    expired: [],
    pending: [],
    premium: [],
    allPending: [],
  },
  returns: {
    completed: [],
    expired: [],
    pending: [],
    premium: [],
    allPending: [],
  },
};

const returnClientStore = create<ReturnClientStore>((set) => ({
  ...initialState,
  updateDashboardReturns: (newReturns) =>
    set((state) => {
      return {
        ...state,
        dashboardReturns: newReturns,
      };
    }),
  updateReturns: (newReturns) =>
    set((state) => {
      return {
        ...state,
        returns: newReturns,
      };
    }),
  clear: () =>
    set((state) => {
      return {
        ...state,
        ...initialState,
      };
    }),
}));

export default returnClientStore;
